import { productActions } from './../../product/product.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { roleActions } from './../../role/role.actions'
import { rolePermissionsActions } from './../role-permission.actions'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { of, Subscription } from 'rxjs'
import { AppState } from 'src/app/core/core.state'

import { Component, OnDestroy, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { take, timeout, catchError } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'

@Component({
  selector: 'role-permissions-create',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class RolePermissionsCreateComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = []

  constructor(
    private store: Store<AppState>,
    private actions$: Actions,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.actions$
        .pipe(ofType(rolePermissionsActions.upsertMany))
        .subscribe((action) => this.router.navigate(['/role-permissions']))
    )

    this.store.dispatch(
      roleActions.fetchMany({
        params: RequestQueryBuilder.create()
      })
    )

    this.store.dispatch(
      productActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: { allowAsLinkedProduct: true, isActive: true },
          join: [{ field: 'translations' }]
        })
      })
    )
  }

  public onSubmit(entities: any[]): void {
    if (entities.length > 1) {
      this.store.dispatch(
        rolePermissionsActions.createMany({
          entities: [entities[0]]
        })
      )
    } else {
      this.store.dispatch(
        rolePermissionsActions.createOne({
          entity: {
            ...entities[0]
          }
        })
      )
    }

    this.actions$
      .pipe(
        ofType(rolePermissionsActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )
  }

  ngOnDestroy() {
    this.subscriptions.map((s) => s.unsubscribe())
  }
}
